// 实时监控
export default {
  path: '/Monitor',
  component: () => import('views/Layout.vue'),
  children: [
    {
      path: 'FaultAlarm',
      name: 'FaultAlarm',
      component: () => import('@/views/webview.vue'),
      meta: {
        _meauname: '故障告警',
        keepAlive: true,
        defaultComponent: () => import('views/realtimeMonitor/faultAlarm.vue'),
      },
    },
    {
      path: 'DeviceMonitor',
      name: 'DeviceMonitor',
      component: () => import('@/views/webview.vue'),
      meta: {
        _meauname: '实时运行',
        keepAlive: true,
        defaultComponent: () => import('views/realtimeMonitor/deviceMonitor.vue'),
      },
    },
    {
      path: 'SiteMap',
      name: 'SiteMap',
      component: () => import('@/views/webview.vue'),
      meta: {
        _meauname: '站点地图',
        keepAlive: true,
        defaultComponent: () => import(/*webpackChunkName: "SiteMap"*/ 'views/marketData/siteMap'),
      },
    },
    {
      path: 'AnOverviewTheSite',
      name: 'AnOverviewTheSite',
      component: () => import('@/views/webview.vue'),
      meta: {
        _meauname: '多站概览',
        keepAlive: true,
        defaultComponent: () => import(/*webpackChunkName: "AnOverviewTheSite"*/ 'views/marketData/siteOverview'),
      },
    },
    {
      path: '/:pathMatch(.*)',
      component: () => import('@/views/webview.vue'),
      meta: {
        _meauname: '实时监控404',
        defaultComponent: () => import('views/404'),
      },
    },
  ],
}
